export default __webpack_public_path__ + "static/media/alert.1062d174.png";